import React, { memo, useMemo } from 'react';
import { Text, Spacer } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import Step from './components/Step/index';
import BrowserMockCard from './components/BrowserMockCard';
import { EMAIL_FOOTER_HTML, CONFIRMATION_PAGE_HTML } from './templates';

import './styles.scss';

const UnsubscribeSettings = memo(() => {
    const emailFooterSrc = useMemo(() => {
        return `data:text/html;charset=utf-8,${encodeURIComponent(EMAIL_FOOTER_HTML)}`;
    }, []);

    const confirmationPageSrc = useMemo(() => {
        return `data:text/html;charset=utf-8,${encodeURIComponent(CONFIRMATION_PAGE_HTML)}`;
    }, []);

    return (
        <div className="unsubscribe-settings">
            <div className="unsubscribe-settings__scroll-container">
                <div className="unsubscribe-settings__header">
                    <Text type="h6" bold>
                        {getLiteral('label_marketing_campaigns_unsubscribe_title')}
                    </Text>
                    <Spacer height="8" />
                    <Text type="body" className="unsubscribe-settings__description">
                        {getLiteral('label_marketing_campaigns_unsubscribe_description')}
                    </Text>
                </div>

                <Spacer height="32" />

                <div className="unsubscribe-settings__steps">
                    <Step
                        number={1}
                        title={getLiteral('label_marketing_campaigns_unsubscribe_footer_title')}
                    >
                        <div className="unsubscribe-settings__iframe-container">
                            <iframe
                                src={emailFooterSrc}
                                className="unsubscribe-settings__iframe"
                                title="Email footer preview"
                                sandbox=""
                            />
                        </div>
                    </Step>

                    <Step
                        number={2}
                        title={getLiteral(
                            'label_marketing_campaigns_unsubscribe_confirmation_title',
                        )}
                    >
                        <BrowserMockCard>
                            <iframe
                                src={confirmationPageSrc}
                                className="unsubscribe-settings__iframe unsubscribe-settings__iframe--confirmation"
                                title="Unsubscribe confirmation preview"
                                sandbox=""
                            />
                        </BrowserMockCard>
                    </Step>
                </div>
            </div>
        </div>
    );
});

UnsubscribeSettings.displayName = 'UnsubscribeSettings';

export default UnsubscribeSettings;
